const stickyHeader = {
    header: document.getElementById('header'),
    sticky: document.getElementById('headerSticky'),
    mainContent: document.getElementById('main-content'),   
    cartPopup: document.getElementById('jsCartWrap'),   
    lastScrollTop: 0,

    init() {
        this.setClass();
        this.sticky.classList.add('init');   
    },

    setClass() {  

        document.addEventListener('scroll', (e) => {
            let st =  document.documentElement.scrollTop;
            if(st === 0) {
                this.header.classList.remove('up');
                this.header.classList.remove('down'); 
                this.sticky.classList.remove('up');
                this.sticky.classList.remove('down'); 
                this.mainContent.classList.remove('up');
                this.mainContent.classList.remove('down');      
                this.cartPopup.classList.remove('up');
                this.cartPopup.classList.remove('down');
            }else if(st !== 0 && st < 300 ) {
                this.header.classList.remove('up');
                this.header.classList.add('down');  
                this.sticky.classList.remove('up');
                this.sticky.classList.add('down');           
                this.mainContent.classList.remove('up');
                this.mainContent.classList.add('down');
                this.cartPopup.classList.add('down');
                this.cartPopup.classList.remove('up');
              
            }else {
                this.header.classList.add('up');
                this.header.classList.remove('down');
                this.sticky.classList.add('up');
                this.sticky.classList.remove('down');
                this.mainContent.classList.add('up');
                this.mainContent.classList.remove('down');  
                this.cartPopup.classList.remove('down');
                this.cartPopup.classList.add('up');            
            }
           
          
        })
    },
}

export default stickyHeader;